export var getRovoChatProduct = function getRovoChatProduct() {
  var product = 'UNKNOWN';
  if (window && window.__ROVO_CHAT_CONFIG_PRODUCT__) {
    product = window.__ROVO_CHAT_CONFIG_PRODUCT__;
  }
  return product;
};